<template>

  <div>
  <!--    <Filters-->
  <!--        :role-filter.sync="roleFilter"-->
  <!--        :plan-filter.sync="planFilter"-->
  <!--        :status-filter.sync="statusFilter"-->
  <!--        :role-options="roleOptions"-->
  <!--        :plan-options="planOptions"-->
  <!--        :status-options="statusOptions"-->
  <!--    />-->
  <b-overlay :show="overlay">
    <b-card
        no-body
        class="mb-0"
    >
      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Mostrar</label>
            <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
            />
            <label>entradas</label>
          </b-col>

          <!-- Search -->
          <b-col
              cols="12"
              md="6"
          >
            <div class="d-flex align-items-center justify-content-end actions-wrapper">
              <b-input-group>
                  <b-form-input
                      v-model="searchInputValue"
                      class="d-inline-block"
                      placeholder="Pesquisar por razão social..."
                      @keyup.enter="handleSearch"
                  />
                  <b-input-group-append>
                    <b-button :disabled="overlay" @click="clearSearch" variant="outline-danger">
                      <feather-icon icon="TrashIcon"/>
                    </b-button>
                    <b-button :disabled="overlay" @click="handleSearch" variant="outline-primary">
                      <feather-icon icon="SearchIcon"/>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              <b-button
                  variant="primary"
                  v-b-modal.modal-add-cliente-dkp-token
                  @click="$store.dispatch('sisDkpClientesTokens/RESERT_DKP_CLIENTE_TOKEN')"
                  class="d-flex"
              >
                <feather-icon
                    icon="PlusIcon"
                    class="mr-50"
                />
                <span class="align-middle">Token Cliente</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
          ref="refDataTableClienteToken"
          class="position-relative"
          :items="fetchDataTablet"
          responsive
          :fields="tableColumns"
          primary-key="log_img_id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="Nenhum registro encontrado"
          :sort-desc.sync="isSortDirDesc"
      >

        <!-- Column: User -->
        <template #cell(cliente)="data">
          <span class="font-weight-bold">{{ data.value.razao_social }}</span>
          <br>
          <span class="text-gray-600">{{ data.value.nome_fantasia }}</span>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              title="Editar Token"
              variant="gradient-primary"
              v-b-modal.modal-add-cliente-dkp-token
              @click="editData(data.item)"
              class="btn-icon mr-1"
          >
            <feather-icon icon="EditIcon" />
          </b-button>

          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              title="Deletar Token"
              variant="gradient-danger"
              @click="showModalDeleted(data.item.id)"
              class="btn-icon mr-1"
          >
            <feather-icon icon="TrashIcon" />
          </b-button>
          <!--            copy token cliente -->
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              title="Copiar Token"
              variant="gradient-info"
              class="btn-icon"
              @click="onCopyToken(data.item)"
          >
            <feather-icon icon="CopyIcon" />
          </b-button>

        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Mostrando {{ dataMeta.from }} para {{ dataMeta.to }} de {{
                dataMeta.of
              }} entradas</span>
          </b-col>
          <!-- Pagination -->
          <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
                v-model="currentPage"
                :total-rows="totalDataTablet"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </b-overlay>
    <modal-confirmation
        v-model="isDeleteModal"
        id-modal="modal-delete-imagem-home"
        title="Deletar Imagem"
        message="Tem certeza que deseja deletar?"
        btn-cancel-label="Cancelar"
        btn-ok-label="sim, deletar"
        @ok="deleteClienteToken"
        @cancel="isDeleteModal = false"
    />
    <modal-add-cliente-dkp-token
        id-modal="modal-add-cliente-dkp-token"
        @add-clienteToken-dkp-token="createOrUpdated"
        @modal-add-cliente-dkp-token="isModalAddClienteDkpToken = false"
        @cancel="isModalAddClienteDkpToken = false"
    />
  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import { avatarText } from '@core/utils/filter';
import ModalConfirmation from '@/components/ModalConfirmation.vue';
import store from '@/store';
import Notifier from '@/libs/Notifier';
import useList from './useList';
import Filters from './Filters.vue';
import ModalAddClienteDkpToken from './ModalAddClienteDkpToken.vue';

export default {
  components: {
    ModalAddClienteDkpToken,
    ModalConfirmation,
    Filters,
  },
  data() {
    return {
      searchInputValue: '',
    };
  },
  methods: {
    handleSearch() {
      this.searchQuery = this.searchInputValue;
    },
    clearSearch() {
      this.searchQuery = '';
      this.searchInputValue = '';
    },
  },
  setup() {
    const notify = new Notifier();
    const isDeleteModal = ref(false);
    const isModalAddClienteDkpToken = ref(false);
    const idDataDeleted = ref(null);
    const roleOptions = [
      { label: 'Admin', value: 'admin' },
      { label: 'Author', value: 'author' },
      { label: 'Editor', value: 'editor' },
      { label: 'Maintainer', value: 'maintainer' },
      { label: 'Subscriber', value: 'subscriber' },
    ];

    const planOptions = [
      { label: 'Basic', value: 'basic' },
      { label: 'Company', value: 'company' },
      { label: 'Enterprise', value: 'enterprise' },
      { label: 'Team', value: 'team' },
    ];

    const statusOptions = [
      { label: 'Pending', value: 'pending' },
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
    ];

    const showModalDeleted = (id) => {
      idDataDeleted.value = id;
      isDeleteModal.value = true;
    };
    const deletedData = async () => {
      await dataDeletedById(idDataDeleted.value);
      isDeleteModal.value = false;
      refetchData();
    };

    const editData = async (data) => {
      store.commit('sisDkpClientesTokens/SET_DKP_CLIENTE_TOKEN', data);
    };

    const onCopyToken = (data) => {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(data.token)
          .then(() => {
            notify.success('Token copiado com sucesso!');
          })
          .catch((err) => {
            console.error('Erro ao copiar token:', err);
            fallbackCopyToClipboard(data.token);
          });
      } else {
        fallbackCopyToClipboard(data.token);
      }
    };

    // Método de fallback para copiar o texto
    const fallbackCopyToClipboard = (text) => {
      const textArea = document.createElement('textarea');
      textArea.value = text;

      // Configurar para ser invisível ao usuário
      textArea.style.position = 'fixed';
      textArea.style.top = '-9999px';
      textArea.style.left = '-9999px';

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        const successful = document.execCommand('copy');
        if (successful) {
          notify.success('Token copiado com sucesso!');
        } else {
          notify.error('Não foi possível copiar o token.');
        }
      } catch (err) {
        console.error('Erro ao executar comando de cópia:', err);
        notify.error('Erro ao copiar o token.');
      }

      document.body.removeChild(textArea);
    };
    const {
      fetchDataTablet,
      tableColumns,
      perPage,
      currentPage,
      totalDataTablet,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataTableClienteToken,
      refetchData,
      overlay,
      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
      dataDeletedById,
      createOrUpdated,
    } = useList();
    const deleteClienteToken = async () => {
      await deletedData(idDataDeleted.value);
      isDeleteModal.value = false;
      refetchData();
    };

    return {
      fetchDataTablet,
      // Sidebar
      isDeleteModal,
      tableColumns,
      perPage,
      currentPage,
      totalDataTablet,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataTableClienteToken,
      refetchData,
      overlay,
      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      roleOptions,
      planOptions,
      statusOptions,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
      deleteClienteToken,
      showModalDeleted,
      isModalAddClienteDkpToken,
      editData,
      deletedData,
      createOrUpdated,
      onCopyToken,
    };
  }
  ,
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.actions-wrapper {
  gap: 0.5rem;
}

@media (max-width: 767.98px) {
  .actions-wrapper {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
  }

  .actions-wrapper .input-group,
  .actions-wrapper .btn {
    width: 100%;
  }

  .actions-wrapper .btn {
    justify-content: center;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
